/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { memo } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

import { Typography } from '../typography';
import { usePage } from '../../api/use';
import usePageNavigation from './usePageNavigation';

const BreadCrumbs = () => {
	const { items, hiliteId } = usePageNavigation();
	const {
		vitality: { loaded },
		menuTitle,
	} = usePage();

	return (
		!!loaded && (
			<div
				css={css`
					margin: 0 0.6em;
					flex: 1 1 auto;
				`}
			>
				<Typography
					size="s"
					weight="thin"
					lineHeight={1}
					css={css`
						letter-spacing: 0.1em;
						text-align: right;
						text-transform: uppercase;
					`}
				>
					{menuTitle}
				</Typography>
				<AnimatePresence>
					{items?.map(
						(item) =>
							item.id === hiliteId && (
								<Typography
									key={item.id}
									as={motion.div}
									initial={{ opacity: 0 }}
									animate={{ opacity: 1 }}
									exit={{ position: 'absolute' }}
									size="xs"
									weight="thin"
									lineHeight={1}
									css={css`
										letter-spacing: 0.1em;
										flex: 1 1 auto;
										text-align: right;
										text-transform: uppercase;
									`}
								>
									{item.label}
								</Typography>
							)
					)}
				</AnimatePresence>
			</div>
		)
	);
};

export default memo(BreadCrumbs);
